import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const namespaced = true

export default {
  namespaced,
  state: {
    tranches: [],
    tranchesPagination: false,
    searchTranches: [],
    searchPagination: false,
    searchDataExist: null,
    pending: true,
    statuses: []
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tranches/index.js